enum PublicApiCommonService {
    Gdpr = 'gdpr',
    Question = 'quest',
    Verification = 'verif',
    Ics = 'ics'
}

export default PublicApiCommonService;